import React from "react";
import ReactECharts from "echarts-for-react";

interface Subtype {
  subtype_id: number;
  subtype_name: string;
  total_time_taken_seconds: number;
}

interface QuestionTypeDetail {
  question_type_name: string;
  subtypes: Subtype[];
}

interface Props {
  question_type_details?: QuestionTypeDetail[] | null;
}

const SubTypeTimeCharts = ({ question_type_details }: Props) => {
  // Prevent crash if data is missing
  const groupedData: Record<
    string,
    Record<string, { name: string; totalTime: number; count: number }>
  > = {};

  if (
    !Array.isArray(question_type_details) ||
    question_type_details.length === 0
  ) {
    return <div>Loading chart data...</div>;
  }

  console.log(question_type_details, "for each");

  // Step 1: Group and merge subtypes
  question_type_details.forEach((qtype) => {
    if (!Array.isArray(qtype.subtypes) || qtype.subtypes.length === 0) return;

    const section = qtype.question_type_name;
    if (!groupedData[section]) groupedData[section] = {};

    qtype.subtypes.forEach((sub) => {
      const key = sub.subtype_name;
      if (!groupedData[section][key]) {
        groupedData[section][key] = {
          name: sub.subtype_name,
          totalTime: sub.total_time_taken_seconds,
          count: 1,
        };
      } else {
        groupedData[section][key].totalTime += sub.total_time_taken_seconds;
        groupedData[section][key].count += 1;
      }
    });
  });

  // Step 2: Convert to chart data (typed cast so TS knows shape)
  const chartData = Object.entries(groupedData).map(([section, subtypes]) => ({
    section,
    data: Object.values(
      subtypes as Record<
        string,
        { name: string; totalTime: number; count: number }
      >
    ).map((s) => ({
      name: s.name,
      avgTimeMinutes: s.totalTime / s.count / 60,
    })),
  }));

  // Step 3: Section chart
  const SectionChart = ({
    section,
    data,
  }: {
    section: string;
    data: { name: string; avgTimeMinutes: number }[];
  }) => {
    const option = {
      title: {
        text: `Average Time per Sub-Type: ${section}`,
        left: "center",
        textStyle: { fontSize: 16 },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: "{b}: {c} min",
      },
      grid: { left: 125, right: 70, bottom: 40, top: 60 },
      xAxis: { type: "value", name: "Minutes" },
      yAxis: {
        type: "category",
        data: data.map((d) => d.name),
        axisLabel: {
          formatter: (value: string) =>
            // value.length > 15 ? value.slice(0, 15) + "…" : value,
            value,
          // "Pattern Recognition",
        },
      },
      series: [
        {
          type: "bar",
          data: data.map((d) => Number(d.avgTimeMinutes.toFixed(2))),
          itemStyle: {
            color: (params: any) =>
              params.value > 1.5 ? "#f56c6c" : "#f7b955",
          },
        },
      ],
    };

    return (
      <div style={{ marginBottom: "40px", overflow: "scroll" }}>
        <ReactECharts option={option} style={{ height: 300 }} />
      </div>
    );
  };

  // Step 4: Render charts
  return (
    <div>
      {chartData.map((section) => (
        <SectionChart
          key={section.section}
          section={section.section}
          data={section.data}
        />
      ))}
    </div>
  );
};

export default SubTypeTimeCharts;
